import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Check } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
export function ContentPhase() {
  return <section className="py-24 px-6 border-b border-ink/10 bg-bone-dark/30" data-id="element-43">
      <div className="max-w-editorial mx-auto" data-id="element-44">
        <SectionHeader number="05" title="📘 CONTENIDO COMPLETO" data-id="element-45" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl bg-bone border border-ink/10 p-8 md:p-12 rounded-sm" data-id="element-46">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-ink text-bone text-sm font-medium tracking-wide uppercase mb-6 rounded-sm" data-id="element-47">
            <BookOpen size={16} data-id="element-48" />
            FASE 1
          </div>

          <h3 className="text-3xl font-serif text-ink mb-6" data-id="element-49">
            La Evaluación de Identidad
          </h3>

          <p className="text-lg text-ink-light font-sans leading-relaxed mb-8" data-id="element-50">
            Tu hoja de ruta para entender la física de tu mente. Aprendé a
            diagnosticar tu nivel de desorganización emocional antes de que se
            convierta en una crisis.
          </p>

          <ul className="space-y-4" data-id="element-51">
            {['Detección precisa del caos mental.', 'Identificación de conductas que aumentan tu ansiedad.', 'Corte definitivo de los bucles de rumiación.'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-52">
                <Check size={20} className="text-sage mt-1 shrink-0" data-id="element-53" />
                <span className="text-ink-light font-sans text-lg" data-id="element-54">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}